import { render } from "./MigrateContability.vue?vue&type=template&id=30f59680&scoped=true"
import script from "./MigrateContability.vue?vue&type=script&lang=js"
export * from "./MigrateContability.vue?vue&type=script&lang=js"

import "./MigrateContability.vue?vue&type=style&index=0&id=30f59680&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f59680"]])

export default __exports__